cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {
        var oldData = data.split(",");
        var result = 0;
        if (oldData != "") {
            oldData.forEach(function (item, index) {
                result += Math.pow(2, parseInt(item) - 1);
            });
        }

        return result;
    };

    var PM_pmc_groupbuying_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            let action = viewmodel.getParams().action;
            //viewmodel.get("temporary").setState('defaultSelectedRowIndexes', true);

            const displayIsGetMemberPrice = (viewmodel) => {
                if ((viewmodel.get("isAllMemberLevel").getValue() == "false" || viewmodel.get("isAllMemberLevel").getValue() == false) && viewmodel.get("groupbuyingmemberlevel").getShowValue()
                    && viewmodel.get("groupbuyingmemberlevel").getShowValue().length == 1) {
                    viewmodel.get("isGetMemberPrice").setDisabled(false);
                } else {
                    viewmodel.get("isGetMemberPrice").setValue(false);
                    viewmodel.get("isGetMemberPrice").setDisabled(true);
                }
                if (viewmodel.get("isAllMemberLevel").getValue() == "true" || viewmodel.get("isAllMemberLevel").getValue() == true) {
                    viewmodel.get("groupbuyingmemberlevel").setVisible(false);
                } else {
                    viewmodel.get("groupbuyingmemberlevel").setVisible(true);
                }
            }

            viewmodel.get("groupbuyingmemberlevel").on('afterValueChange', () => {
                if (viewmodel.get("groupbuyingmemberlevel").getValue() && viewmodel.get("groupbuyingmemberlevel").getValue().length == 1) {
                    viewmodel.get("isGetMemberPrice").setDisabled(false);
                } else {
                    viewmodel.get("isGetMemberPrice").setValue(false);
                    viewmodel.get("isGetMemberPrice").setDisabled(true);
                }
            })

            viewmodel.get("isAllMemberLevel").on('afterValueChange', () => {
                displayIsGetMemberPrice(viewmodel);
            })

            viewmodel.on('afterLoadData', function (data) {

                displayIsGetMemberPrice(viewmodel);

                if (viewmodel.get('labelImage').getValue() !== '' && viewmodel.get('labelImage').getValue() !== undefined) {
                    viewmodel.get('iTag').setValue(1);
                    viewmodel.get("labelImageUrl").setVisible(false);
                } else {
                    viewmodel.get('iTag').setValue(0);
                    viewmodel.get("labelImage").setVisible(false);
                }

                viewmodel.get('iTag').on('afterValueChange', function (data) {
                    if (data.value.value === '0') {
                        viewmodel.get("labelImageUrl").setVisible(true);
                        viewmodel.get("labelImage").setVisible(false);
                    } else {
                        viewmodel.get("labelImageUrl").setVisible(false);
                        viewmodel.get("labelImage").setVisible(true);
                    }
                });
                if (this.getParams().mode === 'add') {
                    //viewmodel.get("temporary").appendRow();
                } else if (this.getParams().mode === 'edit') {

                }

            });

            viewmodel.on('batchModifySetFields', function (args) {
                debugger
                args.forEach((item, index) => {
                    if (item.fieldName === 'sProductCode' || item.fieldName === 'price') {
                        item.bCanModify = false;
                    } else if (item.fieldName === 'productPicUrl') {
                        item.bCanFilter = false;
                    } else if (item.fieldName === 'totalLimitQuantity' || item.fieldName === 'singleLimitQuantity') {
                        item.bCanFilter = true;
                        item.bCanModify = false;
                    }
                })
            })
            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('groupbuyingdetail').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("groupbuyingdetail").deleteRows(rowIndexes);
            })
            // /**点击按钮弹出参照前事件
            //  *返回true则继续进行弹出参照操作，返回false则终止弹出
            //  */
            viewmodel.get("groupbuyingdetail").on('beforeBrowse', function (data) {
                common.productReferBrowseSimple(viewmodel, data, null, "groupbuyingdetail");
                let externalData = { "memberLevelId": null, "iProductType": 0 };
                if ((viewmodel.get('isAllMemberLevel').getValue() == "false" || viewmodel.get('isAllMemberLevel').getValue() == false)
                    && viewmodel.get('isGetMemberPrice').getValue() && viewmodel.get('isGetMemberPrice').getValue() == "true"
                    && viewmodel.get("groupbuyingmemberlevel").getValue() && viewmodel.get("groupbuyingmemberlevel").getValue().length > 0) {
                    externalData.memberLevelId = viewmodel.get("groupbuyingmemberlevel").getValue()[0].iMemberLeverId;
                }
                data.context.setState('externalData', externalData);
                return true;
            });


            // viewmodel.get('groupbuyingdetail').on('afterInsertRow', function (data) {
            //     var defaultAssembleNumbers = viewmodel.get('defaultAssembleNumbers').getValue();
            //     var defaultInitialSales = viewmodel.get('defaultInitialSales').getValue();
            //     if (defaultAssembleNumbers !== undefined) {
            //         this.setCellValue(data.index, 'groupNumbers', defaultAssembleNumbers);
            //     }
            //     if (defaultInitialSales !== undefined) {
            //         this.setCellValue(data.index, 'initialSales', defaultInitialSales);
            //     }
            // });
            viewmodel.get("groupbuyingdetail").on('beforeInsertRowsFromRefer', function (args) {
                var defaultGroupNumbers = viewmodel.get('defaultGroupNumbers').getValue();
                var defaultInitialSales = viewmodel.get('defaultInitialSales').getValue();
                for (var i = 0; i < args.rows.length; i++) {
                    if (defaultGroupNumbers !== undefined) {
                        args.rows[i]['groupNumbers'] = defaultGroupNumbers;
                    }
                    if (defaultInitialSales !== undefined) {
                        args.rows[i]['initialSales'] = defaultInitialSales;
                    }

                }
            });

            viewmodel.get('defaultGroupNumbers').setState('min', 0);
            viewmodel.get('defaultInitialSales').setState('min', 0);
            viewmodel.get("groupbuyingdetail").getEditRowModel().get('price').setState('min', 0);
            viewmodel.get("groupbuyingdetail").getEditRowModel().get('groupNumbers').setState('min', 0);
            viewmodel.get("groupbuyingdetail").getEditRowModel().get('totalLimitQuantity').setState('min', 0);
            viewmodel.get("groupbuyingdetail").getEditRowModel().get('singleLimitQuantity').setState('min', 0);
            viewmodel.get("groupbuyingdetail").getEditRowModel().get('initialSales').setState('min', 0);


            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                obj.memberPayType = setCheckBoxEnum(obj.memberPayType);


                if ((obj.isAllMemberLevel == false || obj.isAllMemberLevel == 'false') && (!this.get('groupbuyingmemberlevel').getShowValue()
                    || this.get('groupbuyingmemberlevel').getShowValue().length == 0)) {
                    alert('适用会员等级不能为空');
                    return false;
                }
                // if (mode == 'add') {
                //     if (viewmodel.get('startTime').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }
                if (this.get('startTime').getValue() >= this.get('endTime').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }
                if (viewmodel.get('groupbuyingdetail').getRows() == '') {
                    cb.utils.alert('所选商品不能为空', 'warning');
                    return false;
                } else {
                    for(let j = 0; j < viewmodel.get('groupbuyingdetail').getRowsCount(); j++){
                      if (!viewmodel.get('groupbuyingdetail').getRows()[j].productId ) {
                        cb.utils.alert('第' + (j + 1) + '行请选择相应的商品信息', 'warning');
                        return false;
                      }
						if(viewmodel.get('groupbuyingdetail').getCellValue(j,'price') <= 0){
							cb.utils.alert('第' + (j+1) +'行 团购价 必须大于0', 'warning');
							return false;
						}

						if(viewmodel.get('groupbuyingdetail').getCellValue(j,'groupNumbers') <= 0){
							cb.utils.alert('第' + (j+1) +'行 成团条件 必须大于0', 'warning');
							return false;
						}
					}
                    if (obj.groupbuyingdetail) {
                        for (let i = 0; i < obj.groupbuyingdetail.length; i++) {
                            let detail = obj.groupbuyingdetail[i];
                            if(action == 'copy'){
								detail.success = 0;
								detail.peopleNumber = 0;
								detail.purchasedProductQuantity = 0;
							}else{
                                if (!detail.purchasedProductQuantity) {
                                    detail.purchasedProductQuantity = 0;
                                }
                                if (!detail.peopleNumber) {
                                    detail.peopleNumber = 0;
                                }
                                if (!detail.singleLimitQuantity) {
                                    detail.singleLimitQuantity = 0;
                                }
                                if (!detail.totalLimitQuantity) {
                                    detail.totalLimitQuantity = 0;
                                }
                            }
                        }
                    }
                }
                if (viewmodel.get('labelImageUrl').getValue() == 1) {
                    obj.labelImageUrl = "/tuangou1.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 2) {
                    obj.labelImageUrl = "/tuangou2.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 3) {
                    obj.labelImageUrl = "/tuangou3.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 4) {
                    obj.labelImageUrl = "/tuangou4.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 5) {
                    obj.labelImageUrl = "/tuangou.png";
                }

                if (viewmodel.get('iTag').getValue() == 0) {
                    obj.labelImage = '';
                } else {
                    if (viewmodel.get('labelImage').getValue == '') {
                        cb.utils.alert('自定义标签未上传', 'warning');
                        return false;
                    } else {
                        obj.labelImageUrl = obj.labelImage;
                    }
                }


                data.data.data = JSON.stringify(obj);

            })
        }
    };
    try {
        module.exports = PM_pmc_groupbuying_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_groupbuying_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_groupbuying_VM.Extend.js